import { useSelector } from 'react-redux';
import { selectGuidesInfo } from 'store/guides/selectors';

import { IGuide } from 'types/guide';

export const useGuides = () => {
    const { userGuides, isLoading, isError } = useSelector(selectGuidesInfo);

    const purchasedGuides = (userGuides as IGuide[]).filter((guide: IGuide) => guide.is_purchased);

    return { isLoading, userGuides, purchasedGuides, isError };
};
